import { NJIcon, NJToggle } from "@engie-group/fluid-design-system-react";
import styles from "./themeToggle.module.css";
import { browserStorage } from "@genai/browser";
import { defaultTheme, Theme, themes, themeStorageKey } from "../model";
import React, { useState } from "react";
import { setTheme } from "./setTheme";

export const ThemeToggle = (): React.ReactElement => {
  const [value, setValue] = useState<Theme>(
    (browserStorage().getItem(themeStorageKey) as Theme) || defaultTheme,
  );
  setTheme(value);
  browserStorage().setItem(themeStorageKey, value);

  return (
    <NJToggle
      id="theme-toggle"
      label="Mode sombre"
      className={styles["genai-theme-toggle"]}
      checked={value === themes.dark}
      values={{
        off: themes.dark,
        on: themes.light,
      }}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => setValue(event.target.value as Theme)}
    >
      <></>
      <NJIcon size="sm" name="dark_mode"></NJIcon>
    </NJToggle>
  );
};
